import React, {useState} from 'react';
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js';
import {PieChart, Pie, Cell, ResponsiveContainer, Tooltip as RechartTooltip, Legend as RechartLegend} from 'recharts';
import TabSwitcher from "../components/tabSwitcher";
import LegendInfo from "../components/legendInfo";
import LoadingBarChart from "../components/loadingBarChart";
import pieColorsDE from "../components/pieColorsDE";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChartSwitcher = ({loading = true, data = []}) => {
    const [activeTab, setActiveTab] = useState('firmenprojekte');

    const firmenprojekteData = data.map(item => ({
        name: item.Status, value: parseFloat(item.Anzahl)
    }));

    const mitarbeiterData = data.map(item => ({
        name: item.Status, value: parseFloat(item.Mitarbeiter)
    }));

    const sumFirmenprojekteData = firmenprojekteData.reduce((acc, item) => acc + item.value, 0);
    const sumMitarbeiterData = mitarbeiterData.reduce((acc, item) => acc + item.value, 0);

    if (loading) {
        return (<div className="flex justify-center items-center h-60 w-full">
            <LoadingBarChart/>
        </div>);
    }

    const selectedData = activeTab === 'firmenprojekte' ? firmenprojekteData : mitarbeiterData;
    const total = activeTab === 'firmenprojekte' ? sumFirmenprojekteData : sumMitarbeiterData;

    return (<div className="flex flex-col items-center justify-center w-full">
        <div className="w-1/2 flex items-center justify-center">
            <TabSwitcher activeTab={activeTab} onTabChange={setActiveTab}/>
        </div>
        <div className="flex flex-row items-center justify-center w-full">
            <div className="w-3/4" style={{height: '63vh'}}>
                <ResponsiveContainer>
                    <PieChart>
                        <Pie
                            data={selectedData}
                            dataKey="value"
                            nameKey="name"
                            outerRadius={275}
                        >
                            {selectedData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={pieColorsDE[entry.name]}/>))}
                        </Pie>
                        <RechartTooltip/>
                    </PieChart>
                </ResponsiveContainer>
            </div>
            <LegendInfo gesamt={total} data={selectedData} className={'w-1/4 ml-4 text-left text-xl'} textSize={"text-xl"}/>
        </div>
    </div>);
};

export default PieChartSwitcher;
